var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.499,
    height: 11.499,
    viewBox: "0 0 11.499 11.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "clock",
    d: "M7.75,4.3a.575.575,0,0,0-.575.575V7.4l-1.4.7a.575.575,0,0,0,.517,1.027l1.714-.862a.574.574,0,0,0,.317-.513V4.875A.575.575,0,0,0,7.75,4.3Zm0-2.3A5.75,5.75,0,1,0,13.5,7.75,5.75,5.75,0,0,0,7.75,2Zm0,10.349a4.6,4.6,0,1,1,4.6-4.6A4.6,4.6,0,0,1,7.75,12.349Z",
    transform: "translate(-2 -2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.065b7b64126a1dca88a5a4566fdfa29c.svg";
export { ForwardRef as ReactComponent };